import React, {useEffect} from 'react';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { FormPageFieldComponentProps } from 'types/formPage';
import _ from 'lodash';
import { withFormikFormControl } from '../FormikFormControl';
import {extract, toDate, toDateText, wrapComponent, toDateRel, wrapArray} from "../utils";
import {useField} from "formik";



type DateTimeFieldComponentProps = FormPageFieldComponentProps & {
  time?:boolean
}
export const DateTimeField = (props: DateTimeFieldComponentProps) => {
  const { value, onChange, extraConfig, name, onBlur, time=true, ...rest } = props;
  const [field,meta,helper] = useField(name)
  const formatOptions = {time, ...extraConfig.format, options: {...extraConfig.options}}
  const {hour24 = false} = formatOptions
  if(_.isEmpty(extraConfig.icon))extraConfig.icon = 'pi pi-calendar'
  if(![undefined,null,''].includes(extraConfig.relMinDate))extraConfig.minDate = toDateRel(extraConfig.relMinDate)
  if(![undefined,null,''].includes(extraConfig.relMaxDate))extraConfig.maxDate = toDateRel(extraConfig.relMaxDate)
  if(extraConfig.minDate)extraConfig.minDate = toDate(extraConfig.minDate, formatOptions)
  if(extraConfig.maxDate)extraConfig.maxDate = toDate(extraConfig.maxDate,formatOptions)
  if(![undefined,null,''].includes(extraConfig.disabledDays))extraConfig.disabledDays = `${extraConfig.disabledDays}`
  if(extraConfig.disabledDates)extraConfig.disabledDates = wrapArray(extraConfig.disabledDates,true).map( d => toDate(d))
  const useValue = toDate(value, formatOptions)
  console.log( '**DATETIME FIELD**', {useValue,value,time,name,formatOptions,extraConfig, rest})
  useEffect( () => {
    if(useValue !== value){
      console.log('**DATETIME FIELD** - Setting Value', {value,useValue})
      helper.setValue(useValue)
    }
  }, [useValue])
  const comp = (
    <Calendar
      name={name}
      onBlur={(e) => {
        console.log('**Calendar onBlur**', {e, value, useValue})
        onBlur(e)
      }}
      value={useValue}
      onChange={(e) => {
        console.log('**Calendar onChange**', {e, value, useValue})
        onChange(e)
      }}
      showTime={time}
      showSeconds={time}
      parseDateTime={date => toDate(date, formatOptions)}
      formatDateTime={date => toDateText(date, formatOptions)}
      {...extract({
        dateFormat: undefined, inline: undefined, mask: undefined,
        hourFormat: hour24 ? '24' : '12', locale: undefined,
        showIcon: undefined, icon: undefined,  iconPos: undefined,  showOnFocus: undefined,  numberOfMonths: undefined,
        view: undefined,  touchUI: undefined,   timeOnly: undefined,  showSeconds: undefined,  showMillisec: undefined,
        stepHour: undefined,  stepMinute: undefined,  stepSecond: undefined,  stepMillisec: undefined,
        shortYearCutoff: undefined,  hideOnDateTimeSelect: undefined, showWeek: undefined,  disabledDates: undefined,
        disabledDays: undefined,   minDate: undefined,  maxDate: undefined,  maxDateCount: undefined,  showMinMaxRange: undefined,
        showOtherMonths: undefined,  selectOtherMonths: undefined,  showButtonBar: true, todayButtonClassName: undefined,   clearButtonClassName: undefined,
      }, extraConfig, rest)}
    />
  );
  return wrapComponent( comp, extraConfig)
};

const DateTimeFormik = withFormikFormControl()(DateTimeField);

export default DateTimeFormik;
